module.exports = __webpack_public_path__ + "img/brand11.9345f755.png";